import { AzureResult } from "../types/azureResult";
import { createNewItem } from "../types/item";
import { ItemUI } from "../types/item";

export function imageFileToItemDataList(file: File): Promise<AzureResult> {
  // construct input to azure API and call it
  const formData = new FormData();
  formData.append("file", file);

  const apiKey = process.env.REACT_APP_AZURE_APIKEY!;
  const url = process.env.REACT_APP_AZURE_ENDPOINT!;
  if (!url || !apiKey) throw new Error("no API key for azure");

  return (
    fetch(url, {
      method: "POST",
      headers: { "Ocp-Apim-Subscription-Key": apiKey },
      body: formData,
    })
      .then((response) => {
        if (!response.ok) throw new Error("Error authenticating azure service");
        return response.headers.get("Operation-Location");
      })

      // continuously check for scanning result at operation-location
      .then((operationLocation) => {
        if (!operationLocation) throw new Error("no Operation-Location header");

        function checkOperationStatus(url: string): Promise<Response> {
          return new Promise((resolve) => setTimeout(resolve, 500))
            .then(() =>
              fetch(url, {
                headers: { "Ocp-Apim-Subscription-Key": apiKey },
              })
            )
            .then((response) => response.json())
            .then((response) => {
              // keep looping
              if (response.status !== "succeeded") {
                return checkOperationStatus(url);
              }
              return response;
            });
        }

        return checkOperationStatus(operationLocation);
      })

      // convert the scanning result into ItemData's
      // TODO: import the typescript type for AzureResult
      .then((azureResult: any): AzureResult => {
        const result = azureResult.analyzeResult.documentResults[0].fields;

        function getAzureItemPrice(itemValueObject: any): number {
          const totalPrice = itemValueObject.TotalPrice;
          if (totalPrice) {
            if (totalPrice.valueNumber) {
              return totalPrice.valueNumber;
            } else if (totalPrice.text) {
              return parseFloat(totalPrice.text.replace(/\D+/g, "")) / 100;
            }
          }

          return 0;
        }

        function convertAzureItem(item: any): ItemUI {
          const name = item.valueObject.Name?.valueString ?? "";
          const price = getAzureItemPrice(item.valueObject);
          return createNewItem(name, price);
        }

        return {
          title: result.MerchantName?.valueString,
          items: result.Items.valueArray.map(convertAzureItem),
          tax: result.Tax?.valueNumber,
          tip: result.Tip?.valueNumber,
        } as AzureResult;
      })

      .catch((error) => {
        throw error;
      })
  );
}
